var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5716 13.6668V6.83345C18.5713 6.53388 18.4895 6.23964 18.3346 5.98028C18.1797 5.72091 17.957 5.50553 17.6888 5.35574L11.5094 1.93908C11.241 1.78914 10.9365 1.71021 10.6266 1.71021C10.3167 1.71021 10.0122 1.78914 9.74384 1.93908L3.56442 5.35574C3.29628 5.50553 3.07358 5.72091 2.91863 5.98028C2.76369 6.23964 2.68196 6.53388 2.68164 6.83345V13.6668C2.68196 13.9664 2.76369 14.2606 2.91863 14.52C3.07358 14.7793 3.29628 14.9947 3.56442 15.1445L9.74384 18.5612C10.0122 18.7111 10.3167 18.79 10.6266 18.79C10.9365 18.79 11.241 18.7111 11.5094 18.5612L17.6888 15.1445C17.957 14.9947 18.1797 14.7793 18.3346 14.52C18.4895 14.2606 18.5713 13.9664 18.5716 13.6668Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91992 5.94507L10.6265 10.2586L18.3332 5.94507",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.627 18.86V10.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.4cf21878ae063ab64d27f9c32242d011.svg";
export { ForwardRef as ReactComponent };